
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","xmlnsXlink":"http://www.w3.org/1999/xlink","width":"17","height":"13","viewBox":"0 0 17 13"},"content":"<defs><path id=\"es42a\" d=\"M265.74 273.1l9.04-9.32 1.43 1.4-10.33 10.66-6.03-5.1 1.3-1.53z\"/></defs><g><g transform=\"translate(-260 -263)\"><g><use xlink:href=\"#es42a\"/></g></g></g>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
